export default "__VITE_ASSET__DDDy6lJn__"